export default __webpack_public_path__ + "static/media/80s_background.dc6d1232.mp3";